import Seo from "@/components/Seo";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import Team from "@/components/Team";
import SocialMatrix from "@/components/SocialMatrix";
import { useLang } from "@/lib/i18n";

export default function TeamPage() {
  const { lang } = useLang();
  return (
    <div className="bg-[#050505] min-h-screen">
      <Seo
        title={lang === "zh" ? "幕后团队 — DFE 娛樂夢工廠" : "Team — Dream Factory Entertainment"}
        description={lang === "zh" ? "DFE 创始团队：音乐人 Isaac（小马）与艺人经理 Eileen Tan，以及马来西亚首家配备认证急救员的娱乐公司。" : "Meet the DFE founders — songwriter Isaac and artist manager Eileen Tan — the first Malaysian entertainment company with certified first aiders."}
      />
      <NavBar />
      <main className="pt-16">
        <Team />
        <SocialMatrix />
      </main>
      <Footer />
    </div>
  );
}
